module.exports = __webpack_public_path__ + "static/media/greyTick.06e24166.svg";